angular.module('labApp').factory('LabReportSelectionResource', function($resource) {
    return $resource('/api/v1.0/lab-reports/selection/', {}, {
        get: { method: 'get', cancellable: true }
    })
});
